import { createAsyncThunk } from "@reduxjs/toolkit";
import { setUserAccess } from "./userAccessSlice";
import { IErrorResponse } from "types";
import request from "service";

const GetUserAccess = createAsyncThunk(
    "get/userAccess",
    async (_, { dispatch, rejectWithValue }) => {
        try {
            const response = await request.get("/users/pending");

            dispatch(setUserAccess(response.data.data));
            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(
                typedError.response.data.message || "unexpected_fail"
            );
        }
    }
);

const ApproveUserAccess = createAsyncThunk(
    "approve/userAccess",
    async (id: number, { rejectWithValue }) => {
        try {
            const response = await request.post(`/users/${id}/activate`);

            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(
                typedError.response.data.message || "unexpected_fail"
            );
        }
    }
);

export { GetUserAccess, ApproveUserAccess };
